import _ from 'lodash';
import {
  FETCH_USER_UNLOCODE_SELECTIONS_SUCCESS,
  SAVE_USER_UNLOCODE_SELECTION_REQUEST,
  DELETE_USER_UNLOCODE_SELECTION_REQUEST,
} from '../../../../user/redux/actions/types/UserActionTypes';
import { ENTERED_WIZARD } from '../../../common/redux/actions/types/SelectionCriteriaWizardActionTypes';
import postalOperatorsMapper from '../mappers/postalOperatorsMapper';
import {
  ARRIVAL_UNLOCODE_CHECKED,
  ARRIVAL_POSTAL_OPERATOR_EXPANDED,
  SELECT_ALL_ARRIVAL_UNLOCODES,
  RETRIEVE_INBOUND_POSTAL_OPERATOR_UNLOCODE_SUCCESS,
  DESELECT_ALL_ARRIVAL_UNLOCODES,
} from '../actions/types/ArrivalPostalOperatorActionTypes';
import filterUnlocodesIfExistsInPostalOperators from '../filters/filterUnlocodesIfExistsInPostalOperators';
import { SWITCH_DEPARTURE_ARRIVAL } from '../actions/types/PostalOperatorActionTypes';
import OperatorTypes from '../../../../common/redux/actions/types/OperatorTypes';
import { LOGGED_OUT } from '../../../../../core/modules/security/redux/actions/types/SecurityActionTypes';
import {
  DELETE_GLOBAL_SELECTION_UNLOCODE_REQUEST,
  SAVE_GLOBAL_SELECTION_UNLOCODE_REQUEST,
} from '../../../../admin/dashboard/redux/actions/types/AdminDashboardActionTypes';

export const initialState = {
  nodes: [],
  checkedUnlocodes: [],
  expandedPostalOperators: [],
  selections: [],
};

const allChildNodeValues = nodes =>
  nodes.map(node => node.children.map(mPC => mPC.value))
    .reduce((initial, unlocodes) => initial.concat(unlocodes));

const handleUserUnlocodeSelectionRequest = (action, state) => {
  const selections = [...state.selections];

  const indexOfExistingSelection = _.findIndex(selections, { name: action.payload.selectionName });
  const newSelection = {
    name: action.payload.selectionName,
    direction: null,
    unlocodes: action.payload.selectedUnlocodes,
  };

  if (indexOfExistingSelection === -1) {
    selections.push(newSelection);
  } else {
    selections[indexOfExistingSelection] = newSelection;
  }

  selections.sort((a, b) => a.name.localeCompare(b.name));

  return {
    ...state,
    selections,
  };
};

const handleAdminUnlocodeSelectionRequest = (action, state) => {
  const selections = [...state.selections];

  const indexOfExistingSelection = _.findIndex(selections, { name: action.payload.selectionName });
  const newSelection = {
    name: action.payload.selectionName,
    direction: null,
    unlocodes: action.payload.selectedUnlocodes,
    scope: 'GLOBAL',
  };

  if (indexOfExistingSelection === -1) {
    selections.push(newSelection);
  } else {
    selections[indexOfExistingSelection] = newSelection;
  }

  selections.sort((a, b) => a.name.localeCompare(b.name));

  return {
    ...state,
    selections,
  };
};

const handleUserUnlocodeSelectionDeleteRequest = (action, state) => {
  let selections = [...state.selections];
  selections = selections.filter(item => item.name !== action.payload);
  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

const handleAdminUnlocodeSelectionDeleteRequest = (action, state) => {
  let selections = [...state.selections];
  selections = selections.filter(item => item.name !== action.payload);
  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

export const arrivalPostalOperatorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_UNLOCODE_SELECTIONS_SUCCESS:
      if (action.payload.postalOperatorType === OperatorTypes.ARRIVAL) {
        return {
          ...state,
          selections: [...action.payload.selections]
            .map(selection => ({
              ...selection,
              name: selection.name === 'LAST_SELECTION' ? 'Your last selection' : selection.name,
            }))
            .sort((a, b) => a.name.localeCompare(b.name)),
        };
      }
      return state;
    case RETRIEVE_INBOUND_POSTAL_OPERATOR_UNLOCODE_SUCCESS:
      return {
        ...state,
        nodes: postalOperatorsMapper(action.payload),
        isLoading: false,
      };
    case ARRIVAL_UNLOCODE_CHECKED:
      return {
        ...state,
        checkedUnlocodes: filterUnlocodesIfExistsInPostalOperators(
          action.checkedUnlocodes,
          state.nodes,
          action.reportDefinition,
        ),
      };
    case ARRIVAL_POSTAL_OPERATOR_EXPANDED:
      return {
        ...state,
        expandedPostalOperators: [...action.expandedPostalOperators],
      };
    case SELECT_ALL_ARRIVAL_UNLOCODES:
      return {
        ...state,
        checkedUnlocodes: allChildNodeValues(action.payload.nodes),
      };
    case DESELECT_ALL_ARRIVAL_UNLOCODES:
      return {
        ...state,
        checkedUnlocodes: [],
      };
    case ENTERED_WIZARD:
      return initialState;
    case SAVE_USER_UNLOCODE_SELECTION_REQUEST:
      return handleUserUnlocodeSelectionRequest(action, state);
    case SAVE_GLOBAL_SELECTION_UNLOCODE_REQUEST:
      return handleAdminUnlocodeSelectionRequest(action, state);
    case DELETE_USER_UNLOCODE_SELECTION_REQUEST:
      return handleUserUnlocodeSelectionDeleteRequest(action, state);
    case DELETE_GLOBAL_SELECTION_UNLOCODE_REQUEST:
      return handleAdminUnlocodeSelectionDeleteRequest(action, state);
    case SWITCH_DEPARTURE_ARRIVAL:
      return {
        ...state,
        ...action.payload.departure,
      };
    case LOGGED_OUT:
      return initialState;
    default:
      return state;
  }
};
